export default "__VITE_ASSET__1fcc06f4__"